import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

const DONATE_URL = 'https://e001e9ac-68a7-4c40-b8ea-95640b3298a4.paylinks.godaddy.com/5d21dd81-b1d5-4b22-8cd2-c45';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/37b30cfd829ed365ed0d2ffa9dcb67f5.jpg')`
        }}
      >
        <div className="text-center text-white max-w-4xl mx-auto px-4 w-full">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Give a Cat a Second Chance
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200">
            Every rescued cat deserves a loving home. Find your perfect feline companion in El Dorado County.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/adoption">
              <Button size="lg" className="bg-orange-600 hover:bg-orange-700 px-8 py-4 whitespace-nowrap">
                <i className="ri-heart-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                Adopt a Cat
              </Button>
            </Link>
            <a href={DONATE_URL} target="_blank" rel="noopener noreferrer">
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 whitespace-nowrap">
                <i className="ri-gift-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                Donate Now
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">About El Dorado Cat Rescue</h2>
              <p className="text-lg text-gray-600 mb-6">
                Founded in 2015, El Dorado Cat Rescue has been a beacon of hope for cats in need throughout El Dorado County. 
                We are a non-profit organization dedicated to rescuing, rehabilitating, and rehoming cats of all ages and backgrounds.
              </p>
              <p className="text-lg text-gray-600 mb-6">
                Our team of passionate volunteers and veterinary professionals work tirelessly to provide medical care, 
                behavioral rehabilitation, and loving foster homes for cats who have been abandoned, abused, or surrendered.
              </p>
              <div className="grid grid-cols-2 gap-6 mb-8">
                <div className="text-center">
                  <div className="text-3xl font-bold text-orange-600 mb-2">500+</div>
                  <div className="text-gray-600">Cats Rescued</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-orange-600 mb-2">450+</div>
                  <div className="text-gray-600">Successful Adoptions</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-orange-600 mb-2">50+</div>
                  <div className="text-gray-600">Active Volunteers</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-orange-600 mb-2">8</div>
                  <div className="text-gray-600">Years of Service</div>
                </div>
              </div>
              <Link to="/blog">
                <Button className="mr-4">Learn More</Button>
              </Link>
              <Link to="/contact">
                <Button variant="outline">Contact Us</Button>
              </Link>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20team%20of%20cat%20rescue%20volunteers%20and%20veterinarians%20caring%20for%20cats%20in%20a%20modern%2C%20open%20animal%20shelter%20facility%20with%20absolutely%20no%20cages%20visible%20anywhere%2C%20diverse%20group%20of%20people%20in%20scrubs%20and%20casual%20clothing%2C%20cats%20roaming%20freely%20in%20comfortable%20open%20spaces%2C%20cats%20being%20examined%20and%20cared%20for%20on%20tables%20in%20open%20areas%2C%20warm%20natural%20lighting%2C%20compassionate%20atmosphere%2C%20high%20quality%20photography&width=600&height=500&seq=about-team-nocages-v2&orientation=landscape"
                alt="Our rescue team caring for cats"
                className="rounded-lg shadow-lg object-cover object-top w-full h-96"
              />
              <div className="absolute -bottom-6 -left-6 bg-orange-500 text-white p-6 rounded-lg shadow-lg">
                <div className="text-2xl font-bold">Every Cat Matters</div>
                <div className="text-orange-100">No cat left behind</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Mission</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              El Dorado Cat Rescue is dedicated to saving, rehabilitating, and rehoming cats in need throughout El Dorado County.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center bg-white p-8 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-pulse-line text-orange-600 w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl font-semibold mb-4">Rescue & Rehabilitate</h3>
              <p className="text-gray-600">
                We rescue cats from shelters, streets, and difficult situations, providing medical care and rehabilitation.
              </p>
            </div>

            <div className="text-center bg-white p-8 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-home-heart-line text-blue-600 w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl font-semibold mb-4">Find Forever Homes</h3>
              <p className="text-gray-600">
                We carefully match cats with loving families to ensure successful, lifelong adoptions.
              </p>
            </div>

            <div className="text-center bg-white p-8 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-community-line text-green-600 w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl font-semibold mb-4">Community Education</h3>
              <p className="text-gray-600">
                We educate the community about responsible pet ownership and the importance of spaying/neutering.
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* Featured Cats Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Cats Looking for Homes</h2>
            <p className="text-xl text-gray-600">
              Meet some of our wonderful cats who are ready for their forever homes
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Beautiful%20black%20and%20white%20domestic%20shorthair%20cat%20sitting%20gracefully%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%20style%2C%20soft%20natural%20lighting%2C%20adorable%20expression%2C%20high%20quality%20portrait&width=400&height=300&seq=featured1&orientation=landscape"
                alt="Luna - Black & White Cat"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">Luna</h3>
                <p className="text-gray-600 mb-4">2 years • Female • Playful &amp; Affectionate</p>
                <Link to="/adoption">
                  <Button className="w-full">Learn More</Button>
                </Link>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Handsome%20orange%20tabby%20Maine%20Coon%20mix%20cat%20with%20long%20fluffy%20fur%20sitting%20peacefully%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20warm%20lighting%2C%20gentle%20expression%2C%20high%20quality%20portrait&width=400&height=300&seq=featured2&orientation=landscape"
                alt="Whiskers - Orange Tabby"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">Whiskers</h3>
                <p className="text-gray-600 mb-4">4 years • Male • Calm &amp; Gentle</p>
                <Link to="/adoption">
                  <Button className="w-full">Learn More</Button>
                </Link>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Adorable%20young%20calico%20cat%20with%20beautiful%20tri-color%20pattern%20sitting%20alertly%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%20style%2C%20bright%20natural%20lighting%2C%20curious%20expression%2C%20high%20quality%20portrait&width=400&height=300&seq=featured3&orientation=landscape"
                alt="Mittens - Calico Cat"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">Mittens</h3>
                <p className="text-gray-600 mb-4">1 year • Female • Energetic &amp; Social</p>
                <Link to="/adoption">
                  <Button className="w-full">Learn More</Button>
                </Link>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Elegant%20gray%20longhair%20domestic%20cat%20with%20fluffy%20coat%20sitting%20majestically%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20soft%20lighting%2C%20calm%20dignified%20expression%2C%20high%20quality%20portrait&width=400&height=300&seq=featured4&orientation=landscape"
                alt="Shadow - Gray Longhair"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">Shadow</h3>
                <p className="text-gray-600 mb-4">3 years • Male • Independent &amp; Quiet</p>
                <Link to="/adoption">
                  <Button className="w-full">Learn More</Button>
                </Link>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Beautiful%20Siamese%20mix%20cat%20with%20seal%20point%20coloring%20and%20bright%20blue%20eyes%20sitting%20elegantly%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20natural%20lighting%2C%20alert%20intelligent%20expression%2C%20high%20quality%20portrait&width=400&height=300&seq=featured5&orientation=landscape"
                alt="Bella - Siamese Mix"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">Bella</h3>
                <p className="text-gray-600 mb-4">5 years • Female • Vocal &amp; Intelligent</p>
                <Link to="/adoption">
                  <Button className="w-full">Learn More</Button>
                </Link>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Stunning%20Bengal%20mix%20cat%20with%20brown%20spotted%20pattern%20and%20muscular%20build%20sitting%20proudly%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20dramatic%20lighting%2C%20confident%20expression%2C%20high%20quality%20portrait&width=400&height=300&seq=featured6&orientation=landscape"
                alt="Tiger - Bengal Mix"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">Tiger</h3>
                <p className="text-gray-600 mb-4">6 years • Male • Active &amp; Adventurous</p>
                <Link to="/adoption">
                  <Button className="w-full">Learn More</Button>
                </Link>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Gorgeous%20white%20Persian%20mix%20cat%20with%20long%20fluffy%20fur%20and%20round%20face%20sitting%20gracefully%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20soft%20lighting%2C%20sweet%20gentle%20expression%2C%20high%20quality%20portrait&width=400&height=300&seq=featured7&orientation=landscape"
                alt="Snowball - Persian Mix"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">Snowball</h3>
                <p className="text-gray-600 mb-4">2 years • Female • Gentle &amp; Quiet</p>
                <Link to="/adoption">
                  <Button className="w-full">Learn More</Button>
                </Link>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Handsome%20tuxedo%20cat%20with%20black%20and%20white%20markings%20sitting%20confidently%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%20style%2C%20natural%20lighting%2C%20friendly%20expression%2C%20high%20quality%20portrait&width=400&height=300&seq=featured8&orientation=landscape"
                alt="Patches - Tuxedo Cat"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">Patches</h3>
                <p className="text-gray-600 mb-4">3 years • Male • Friendly &amp; Social</p>
                <Link to="/adoption">
                  <Button className="w-full">Learn More</Button>
                </Link>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Adorable%20young%20orange%20female%20cat%20with%20bright%20coat%20sitting%20playfully%20in%20a%20clean%20white%20studio%20background%2C%20professional%20pet%20photography%2C%20warm%20lighting%2C%20sweet%20kitten-like%20expression%2C%20high%20quality%20portrait&width=400&height=300&seq=featured9&orientation=landscape"
                alt="Ginger - Orange Female"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">Ginger</h3>
                <p className="text-gray-600 mb-4">1 year • Female • Playful &amp; Sweet</p>
                <Link to="/adoption">
                  <Button className="w-full">Learn More</Button>
                </Link>
              </div>
            </div>
          </div>

          <div className="text-center">
            <Link to="/adoption">
              <Button size="lg" className="px-8">
                View All Available Cats
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Latest from Our Blog</h2>
            <p className="text-xl text-gray-600">
              Stay updated with rescue stories, cat care tips, and volunteer opportunities
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <article className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Happy%20volunteers%20of%20different%20ages%20working%20together%20at%20an%20open%20animal%20shelter%20with%20no%20cages%2C%20feeding%20cats%20in%20open%20spaces%2C%20cleaning%20comfortable%20areas%2C%20playing%20with%20cats%20roaming%20freely%2C%20diverse%20group%20of%20people%20in%20volunteer%20t-shirts%2C%20warm%20community%20atmosphere%2C%20professional%20photography&width=400&height=250&seq=blog1-nocages&orientation=landscape"
                alt="Volunteers helping cats"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <div className="text-sm text-orange-600 font-semibold mb-2">VOLUNTEER</div>
                <h3 className="text-xl font-semibold mb-3">How You Can Volunteer and Make a Difference</h3>
                <p className="text-gray-600 mb-4">
                  Discover the many ways you can volunteer with us and help save cats in need. From fostering to fundraising, every contribution matters.
                </p>
                <Link to="/blog" className="text-orange-600 hover:text-orange-700 font-semibold">
                  Read More →
                </Link>
              </div>
            </article>

            <article className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Heartwarming%20cat%20adoption%20success%20story%20showing%20a%20happy%20family%20with%20their%20newly%20adopted%20rescue%20cat%20in%20a%20cozy%20home%20setting%2C%20smiling%20people%20holding%20a%20beautiful%20cat%20in%20an%20open%20living%20room%2C%20warm%20lighting%2C%20emotional%20moment%2C%20professional%20photography%2C%20no%20cages%20anywhere&width=400&height=250&seq=blog2-nocages&orientation=landscape"
                alt="Cat adoption success story"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <div className="text-sm text-blue-600 font-semibold mb-2">SUCCESS STORY</div>
                <h3 className="text-xl font-semibold mb-3">Luna Finds Her Forever Home</h3>
                <p className="text-gray-600 mb-4">
                  Read about Luna's incredible journey from a scared stray to a beloved family member, and how love transformed her life.
                </p>
                <Link to="/blog" className="text-orange-600 hover:text-orange-700 font-semibold">
                  Read More →
                </Link>
              </div>
            </article>

            <article className="bg-white rounded-lg shadow-md overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20veterinarian%20examining%20a%20cat%20in%20a%20modern%20open%20clinic%20setting%2C%20medical%20equipment%20visible%2C%20caring%20hands%20checking%20cat%20health%20on%20examination%20table%20in%20open%20space%2C%20clean%20white%20environment%2C%20professional%20healthcare%20photography%2C%20no%20cages%20visible&width=400&height=250&seq=blog3-nocages&orientation=landscape"
                alt="Cat health and care tips"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <div className="text-sm text-green-600 font-semibold mb-2">HEALTH TIPS</div>
                <h3 className="text-xl font-semibold mb-3">Essential Cat Health Care Tips</h3>
                <p className="text-gray-600 mb-4">
                  Learn important health care tips to keep your feline friend happy and healthy throughout their life.
                </p>
                <Link to="/blog" className="text-orange-600 hover:text-orange-700 font-semibold">
                  Read More →
                </Link>
              </div>
            </article>
          </div>

          <div className="text-center">
            <Link to="/blog">
              <Button size="lg" className="px-8">
                View All Blog Posts
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* How to Help Section */}
      <section className="py-20 bg-orange-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">How You Can Help</h2>
            <p className="text-xl text-gray-600">
              There are many ways to support our mission and help cats in need
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-money-dollar-circle-line text-orange-600 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-2xl font-semibold">Make a Donation</h3>
              </div>
              <p className="text-gray-600 mb-6">
                Your financial support helps us provide medical care, food, and shelter for cats in need. 
                Every donation makes a difference in a cat&apos;s life.
              </p>
              <a href={DONATE_URL} target="_blank" rel="noopener noreferrer">
                <Button className="w-full whitespace-nowrap">Donate Now</Button>
              </a>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-gift-line text-blue-600 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="text-2xl font-semibold">Donate Supplies</h3>
              </div>
              <p className="text-gray-600 mb-6">
                We always need cat food, litter, toys, and other supplies. 
                Check our wish list and drop off items at our location.
              </p>
              <Link to="/contact">
                <Button variant="outline" className="w-full whitespace-nowrap">Contact Us</Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
